import axios from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, {
  retries: 1,
  retryDelay: (retryCount) => {
    return retryCount * 2000;
  },
  shouldResetTimeout: true,
  retryCondition: (_error) => true // retry no matter what
});

export function ApiDownloader(type, token, apiRoute, apiParams, form) {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    Accept: "/",
    Authorization: "Bearer " + token,
    "Content-Type": "application/json"
  };
  let params = apiParams ? apiParams : "";
  if (type === "post")
    return axios.post(apiRoute, params, { headers, responseType: "blob" });
  else return "error";
}
